import React from 'react';

import api     from '../../../api';
import Context from '../../../context';
import values  from '../../../values';

import { useQuery }        from 'react-query';
import { TModal }          from '../../../types/common.type';
import successHandler      from '../../../utils/successHandler';
import { IAcademicYear, IAcademicYearForm } from '../../../types/academicYear.interface';

import AcademicYearScreen from '..';

const AcademicYearContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedYear, setSelectedYear] = React.useState<IAcademicYear | undefined>(undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Deliberately the same query key components/Layout uses, so adding or renaming a year refreshes the panel-wide
  // ? selector in the header without a reload.
  const getAcademicYears = useQuery(
    [values.useQueryKeys.getAllAcademicYear],
    () => api.get.common.getAllAcademicYear()
  );

  const academicYears: IAcademicYear[] = getAcademicYears?.data?.result?.docs ?? [];

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(values: IAcademicYearForm): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createAcademicYear(values);
    successHandler(result?.CODE);
    await getAcademicYears.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(values: IAcademicYearForm): Promise<void> {
    if (!selectedYear) return;
    setIsLoading(true);
    const result = await api.patch.administrator.updateAcademicYear(selectedYear._id, values);
    successHandler(result?.CODE);
    await getAcademicYears.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function deleteFunction(): Promise<void> {
    if (!selectedYear) return;
    setIsLoading(true);
    // ? The API refuses this while services still belong to the year; errorHandler surfaces that to the user.
    const result = await api.dele.administrator.deleteAcademicYear(selectedYear._id);
    successHandler(result?.CODE);
    await getAcademicYears.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  return (
    <Context.AcademicYearScreen.Provider
      value={{
        showModal,
        isLoading,
        academicYears,
        selectedYear,
        setShowModal,
        setSelectedYear,
        createFunction,
        updateFunction,
        deleteFunction,
      }}
    >
      <AcademicYearScreen rqData={getAcademicYears} />
    </Context.AcademicYearScreen.Provider>
  );
};

export default AcademicYearContainer;
